import { render, staticRenderFns } from "./version-announcement.vue?vue&type=template&id=65938a07&scoped=true&"
import script from "./version-announcement.vue?vue&type=script&lang=js&"
export * from "./version-announcement.vue?vue&type=script&lang=js&"
import style0 from "./version-announcement.vue?vue&type=style&index=0&id=65938a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65938a07",
  null
  
)

export default component.exports